<template>
  <div class="doc">
    <div class="title">
      <h1>共享经济合作伙伴协议</h1>
    </div>
    <div class="article">
      <dl>

<dd>（在本协议下，辽宁智存融汇和用户统称为“双方”，或各自被称为“各方”或“一方”。）</dd>
<dt><u>特别提示：</u></dt>
<dd><u>针对获得生产经营所得的自由职业者在使用本协议项下辽宁智存融汇（还包括辽宁智存融汇指定的合作方、关联方及其他分支机构，下同）提供的共享经济综合服务时，辽宁智存融汇承诺依法纳税、确保自然纳税人取得税后的合法收入。</u></dd>
<dd><u>军人、公职人员等国家法律法规和纪律规定禁止从事兼职或经商的人员，严禁使用本协议项下辽宁智存融汇提供的共享经济综合服务。</u></dd>
<dd><u>公司雇员等其他与公司具有劳动/劳务合同关系、或其他类似的劳动人事法律关系并从与其有前述关系的公司取得工资薪金所得的人员，严禁使用本协议项下辽宁智存融汇提供的共享经济综合服务；该类人员因从事生产经营而从非与其有前述关系的企、事业单位所取得的生产经营所得，辽宁智存融汇可为其提供本协议项下的共享经济综合服务。</u></dd>
<dd><u>公司法定代表人、股东、董事、监事等其他从所属公司取得收入的人员，一律严禁使用本协议项下辽宁智存融汇提供的共享经济综合服务；该类人员因从事生产经营而从非与其有前述关系的企、事业单位所取得的生产经营所得，辽宁智存融汇可为其提供本协议项下的共享经济综合服务。</u></dd>
<dd><u>一经发现有上述任一行为的，用户应自行承担相关法律责任。</u></dd>
<dd><u>上述“公司”特指与用户建立业务关系并提供相应生产经营活动的公司，用户与其他公司之间的法律关系不受上述条款约束。</u></dd>
<dd>依据《中华人民共和国税收征收管理法》及其细则、《中华人民共和国民法典》、《中华人民共和国发票管理办法》、《委托代征管理办法》等相关法律法规的规定，甲乙双方经协商一致，达成协议如下：</dd>

<dt>1、	定义</dt>
<dd>1.1.	辽宁智存融汇系国内注册成立的科技公司，接受用户委托，为用户提供共享经济综合服务。主要包括基于您的资质或个人技能为您匹配适合的生产经营活动以及核算生产经营收入等。</dd>
<dd>1.2.	用户系具有完全的民事行为能力且具备相应专业技能及许可（如有）的自由职业者，接受辽宁智存融汇（包括辽宁智存融汇指定的合作方、关联方及其他分支机构，下同）提供的共享经济综合服务，与辽宁智存融汇或辽宁智存融汇企业客户之间建立业务关系并提供相应的生产经营活动。用户承诺作为服务提供者，应遵守国家相关法律法规及行业规范，按照辽宁智存融汇与企业客户的业务具体要求完成服务内容，履行生产经营活动过程中的相关义务并享有相关权利。</dd>
<dt>2、	合作内容</dt>
<dd>2.1.	用户应自行负担就其生产经营所得需缴纳的各项税款及行政收费（如有），辽宁智存融汇及辽宁智存融汇指定的合作方、关联方及其他分支机构按照有关税收政策规定及相关主管税务机关的要求，接受用户委托协助其向主管税务机关缴纳或代征前述税费。</dd>
<dd>2.2.	辽宁智存融汇及辽宁智存融汇指定的合作方、关联方及其他分支机构接受用户委托，通过本协议项下的服务将用户生产经营所得完税后的金额发放至用户，并接受用户委托由辽宁智存融汇或主管税务机关代开增值税普通发票。</dd>
<dt>3、	辽宁智存融汇权利义务</dt>
<dd>3.1.	辽宁智存融汇有权就用户提供的生产经营活动制定相应规则及标准，用户应当遵守。</dd>
<dd>3.2.	辽宁智存融汇协助用户获取生产经营所得时，应当按照有关税收政策规定及主管税务机关授予的代征权限向用户代征个人所得税等各项税款及行政收费（如有），或协助用户按照有关税收政策规定及主管税务机关的要求缴纳个人所得税等各项税款及行政收费（如有）。</dd>
<dd>3.3.	辽宁智存融汇有权对用户提供的信息进行验证，但该等验证行为并不意味着辽宁智存融汇对用户信息的真实性、有效性、合法性、完整性负责，也并不因此减轻或免除用户的任何义务或责任。</dd>
<dd>3.4.	辽宁智存融汇发现用户违反相关法律法规或本协议规定的，辽宁智存融汇有权中止本协议。用户应自行承担由此产生的税务相关的处罚责任，包括但不限于根据税务机关的要求补缴相应的税款、滞纳金等。</dd>
<dd>3.5.	辽宁智存融汇承诺对用户所披露的个人隐私信息进行保密。</dd>
<dd>3.6.	辽宁智存融汇可以留存为实现本次合作内容从用户处获取的用户个人信息。但是，未经用户授权，辽宁智存融汇不得将用户个人信息披露给任何第三方。</dd>
<dd>3.7.	辽宁智存融汇承诺将按照相关法律法规的要求，对从用户处获得的用户个人信息履行安全保护义务，保障网络免受干扰、破坏或未经授权的访问，防止网络数据泄露或被窃取、篡改。</dd>
<dd>3.8.	如用户与其客户之间如有非因本协议产生的争议或纠纷的，与辽宁智存融汇无关，辽宁智存融汇不承担任何责任。</dd>
<dd>3.9.	辽宁智存融汇向用户提供本协议项下服务在任何情况下均不得被理解为与用户之间建立或存在劳动/劳务合同关系、或其他类似的劳动人事法律关系。</dd>
<dt>4、	用户权利义务</dt>
<dd>4.1.	用户保证提供的个人信息等均是真实的、有效的、合法的、完整的，如信息变更应当及时通知辽宁智存融汇，与此有关的全部法律责任由用户承担。同时，用户知悉并确认，当且仅当其通过了辽宁智存融汇系统或辽宁智存融汇合作的第三方系统的实名认证后，方能享有本协议项下的服务。</dd>
<dd>4.2.	用户保证提供各项业务往来信息，包括但不限于业务合作协议、相关补充协议及业务结算单等，均是真实的、有效的、合法的、完整的，如信息变更应当及时通知辽宁智存融汇，与此有关的全部法律责任由用户承担。</dd>
<dd>4.3.	用户有义务向辽宁智存融汇提供与生产经营所得相对应的收入凭据，并保证其均是真实的、有效的、合法的、完整的，如信息变更应当及时通知辽宁智存融汇，与此有关的全部法律责任由用户承担。</dd>
<dd>4.4.	用户有义务自行保护账户信息的安全，任何通过用户账户进行的操作均将被视为用户的真实意思表示，相应责任均由用户自行承担。</dd>
<dd>4.5.	用户承诺与其客户之间不具有下列关系：</dd>
<dd>1)	与客户具有劳动/劳务合同关系、或其他类似的劳动人事法律关系；</dd>
<dd>2)	与客户的关联企业具有劳动/劳务合同关系、或其他类似的劳动人事法律关系；</dd>
<dd>3)	为客户及其关联企业的法定代表人、董事、监事、股东；</dd>
<dd>4)	其他不适用于本协议适用范围之规定的人员关系。</dd>
<dd>4.6.	用户发现辽宁智存融汇违反法律、行政法规的规定或者双方的约定收集、使用其个人信息的，有权要求其删除其个人信息；发现辽宁智存融汇收集、存储的其个人信息有错误的，有权要求其予以更正。辽宁智存融汇应当采取措施予以删除或者更正。</dd>
<dd>4.7.	用户保证活动过程中遵守国家法律法规，因用户个人原因造成其个人或任何第三方损害的责任，由用户承担全部法律责任。</dd>
<dd>4.8.	用户不得申请代开以下发票：</dd>
<dd>1)	凡带有抵扣功能的普通发票；</dd>
<dd>2)	非税务部门管理的经营收入。</dd>
<dd>4.9.	用户承诺应当基于真实业务交易向辽宁智存融汇申请代开或委托辽宁智存融汇由税务机关代开相应发票并提供真实、准确、完整的开票信息，否则若用户违反该承诺造成的相关法律责任及损失由用户自行承担，若由此造成辽宁智存融汇损失或被相关行政机关处罚的，用户应当承担赔偿责任。</dd>
<dd>4.10.	用户不得从事违反法律及行政法规等行为，如洗钱、偷税漏税及其他辽宁智存融汇认为不得使用辽宁智存融汇服务的行为等。</dd>
<dd>4.11.	用户确认，其具有完全民事权利能力及完全民事行为能力，所有业务合作均为其真实意愿，且遵守国家法律法规及行业监管要求并满足所有履行本协议所需的法定条件或约定条件。</dd>
<dd>4.12.	用户确认，已知晓其生产经营所得的计算方式及结算周期。</dd>
<dd>4.13.	用户可自行在企业客户处查询生产经营所得的计算方式、结算周期、支付途径等信息，如有异议，可直接与企业客户沟通，辽宁智存融汇可在必要时提供相关协助。</dd>
<dd>4.14.	用户理解并同意，辽宁智存融汇仅能根据用户的委托及主管税务机关规定的或授予的委托代征范围、期限，及税种、税率等，协助用户缴纳相关税费或依法代征相关税费，各地主管税务机关的具体规定可能不一致。同时，如遇国家或地方政府及主管税务机关政策变更的，辽宁智存融汇有权根据变更后的政策规定自动调整本协议项下的权利义务乃至终止本协议。</dd>
<dd>4.15.	为便利业务的开展，根据实际业务情况，辽宁智存融汇可能会安排一家或多家合作方、关联方及/或分支机构作为实际业务提供方，为用户提供本协议项下约定的服务，用户对此知情并完全同意。同时，用户同意授权并委托辽宁智存融汇为其申请数字证书，并签署所需的相关协议，但该协议应以不加重用户的合同义务为限。</dd>
<dd>4.16.	用户知悉并同意，经数字证书签署后的电子合同，与用户以纸质形式进行的签章具有同等法律效力，对用户具有不可撤销的法律约束力。用户不得以未签署纸质合同为由、或未实际操作数字证书等理由，否认该等电子合同的法律效力。</dd>
<dt>5、	保密条款</dt>
<dd>5.1.	本协议任何一方应对本协议所涉及的所有内容以及协议各方在执行本协议过程中相关的一切法律、商业、合作业务的所有资讯进行保密。未经对方允许，均不得向对方以外的任意第三方披露。</dd>
<dd>5.2.	保密期应为：协议的有效期内及协议终止之后的十年。</dd>
<dt>6、	违约责任</dt>
<dd>任何一方违反本协议约定，即构成该方的违约；除本协议另有规定外，违约方应向守约方承担违约责任，补偿守约方承受或遭致的所有损失、责任、赔偿金或费用（包括但不限于合理的律师费、诉讼费、公证费等）。</dd>
<dt>7、	其他</dt>
<dd>7.1.	在本协议的任意一方或双方未能及时行使本协议项下的权利不应被视为放弃该权利，也不影响该方在将来行使该权利。</dd>
<dd>7.2.	本协议的订立、执行和解释及争议的解决均应适用中国法律。凡因本协议引起的或与本协议有关的任何争议，协议各方应友好协商解决。如不能协商解决，双方一致同意提交至北京仲裁委员会仲裁。</dd>
<dd>7.3.	双方同意，在本协议签订后，如另有补充协议，该等补充协议及附件构成本协议不可分割的组成部分，具有同等法律效。</dd>
<dd>7.4.	本协议项下各方声明、承诺和保证：本协议任何一方已披露签署和履行本协议所应当向另一方披露的全部信息，且披露内容真实、准确、无遗漏。协议各方同时声明和承诺：本协议的签署和履行不与本协议任何一方已经签署的协议或需承担的任何义务相冲突，且也不会对本协议任何一方以外的第三方形成任何法律和商业上的冲突。</dd>
<dd>7.5.	除本协议另有约定外，在履行本协议过程中的一切通知，其中：以电子方式发出的书面通知，包括但不限于向您的联系电话发送手机短信、向您的电子邮箱发送电子邮件及通过客服向您发送通知，通知在发送成功后即视为送达。</dd>
<dd>7.6.	本协议经用户签章之日起生效，本协议有效期为壹年。协议到期后如双方均未以书面方式提出异议，则本协议有效期自动顺延壹年。本协议壹式贰份，甲乙双方各执壹份，每份具有同等法律效力。</dd>



      </dl>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sharing_economy_partnership_agreement',
    props: ['app'],
    mounted () {
      document.title = document.querySelector('.title').textContent
    },
  }
</script>
